<ngx-ui-loader [fgsType]="'folding-cube'" fgsColor="#FFC72E" [hasProgressBar]="false"></ngx-ui-loader>
<div id="preloader" 
    class="preloader">
    Loading...
</div> 
<router-outlet></router-outlet>